import request from '@/utils/request'

export function SendMessage(data) {
    return request({
      url: 'XthHub/SendMessage',
      method: 'post',
      data,
    })
  }